export default "__VITE_ASSET__DGAr300h__"